import ScrollPanel from './ScrollPanel.vue'

export default ScrollPanel



// WEBPACK FOOTER //
// ./src/app/components/common/scrollPanel/index.js